import actions from '../../constants/actions';

export const loadCategories = () => {
  return {
    type: actions.CATEGORIES.LOAD
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/categories.js